import {
  faCircleCheck,
  faCircleExclamation
} from '@fortawesome/pro-duotone-svg-icons'
import { Box, Stack } from '@mui/material'
import { memo } from 'react'

import Button from '../button/Button'
import FaIcon from '../faIcon/FaIcon'
import Text from '../text/Text'

const TierRequirementBox = ({
  title,
  completed,
  action,
  desc,
  refresh,
  rightAction
}) => {
  return (
    <Box
      sx={{
        color: 'var(--layout-nav-text-primary-color)',
        bgcolor: 'background.neutral',
        borderRadius: 2,
        p: 2,
        gap: 1,
        display: 'flex',
        flexDirection: 'column',
        width: 1
      }}
    >
      <Stack direction='row' spacing={1} alignItems='center' sx={{ width: 1 }}>
        <Box
          color={completed ? 'success.main' : 'default.main'}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <FaIcon
            icon={completed ? faCircleCheck : faCircleExclamation}
            size='2x'
          />
        </Box>
        {title && <Text label={title} color='inherit' variant='h6' />}
        {rightAction && (
          <Stack alignItems='flex-end' flexGrow={1}>
            <Button {...rightAction} />
          </Stack>
        )}
      </Stack>
      <Stack spacing={1} sx={{ width: 1 }}>
        {desc}
        {(action || refresh) && (
          <Stack
            alignItems='flex-end'
            direction='row'
            justifyContent='end'
            spacing={2}
          >
            {refresh}
            {action}
          </Stack>
        )}
      </Stack>
    </Box>
  )
}

export default memo(TierRequirementBox)
